<script lang="ts">
  import { getContext, type Snippet } from 'svelte'
  import type { ToggleGroupContext } from './ToggleGroup.svelte'
  import Tooltip from '../tooltip/Tooltip.svelte'

  type Props = { children: Snippet, title: string }

  const { children, title }: Props = $props()

  const { selected, name, type } = getContext(
    'toggle-group',
  ) as ToggleGroupContext
</script>

<Tooltip {title}>
  <label>
    {@render children()}
    <input
      name={$name}
      class="input"
      checked={!$selected}
      onchange={() => {
        $selected = null
      }}
      type={$type == 'multiple' ? 'checkbox' : 'radio'}
      value="reset"
    />
  </label>
</Tooltip>

<style lang="scss">
  label {
    align-items: center;
    border-radius: 0.25rem;
    cursor: pointer;
    display: flex;
    height: 1.625rem;
    justify-content: center;
    min-height: 1.625rem;
    overflow: hidden;
    padding: 0 .5rem;

    input {
        display: none;
    }

    :global(svg) {
        min-width: 1rem;
        min-height: 1rem;
        height: 1rem;
        width: 1rem;
    }

    &:has(input:checked) {
        background-color: var(--toggle-group-item-active-background);
    }

    &:focus-visible {
        outline: 1px solid var(--stroke);
        outline-offset: -1px;
    }
}
</style>
